import { action } from 'sky-engine/api/index'

import { SCENE_MNG, SCENE_COLLECT_MNG } from '@/api/apiModules'

/**
 * 获取行业与场景规格数据
 * @param {*} data
 * @returns
 */
export function getSceneDetail(data) {
  return action(SCENE_MNG, 'detail', data)
}

/**
 * 获取行业与场景规格数据
 * @param {*} data
 * @returns
 */
export function queryScenes(data) {
  return action(SCENE_MNG, 'queryScenes', data)
}

/**
 * 获取场景与系列之间的关系
 * @param {*} data
 * @returns
 */
export function relateProduct(data) {
  return action(SCENE_MNG, 'relate/product', data)
}

/**
 * 获取场景与版本之间的关系
 * @param {*} data
 * @returns
 */
export function relateProductVersion(data) {
  return action(SCENE_MNG, 'relate/product/version', data)
}

/**
 * 获取场景和采集绑定的列表详情
 * @param {*} data
 * @returns
 */
export function sceneBindDetail(data) {
  return action(SCENE_COLLECT_MNG, 'sceneBindDetail', data)
}

/**
 * 获取报告详情（终端、外设、软件）
 * @param {*} data
 * @returns
 */
export function collectDetail(data) {
  return action(SCENE_COLLECT_MNG, 'collectDetail', data)
}

/**
 * 保存环境信息采集
 * @param {*} data
 * @returns
 */
export function updateSceneRealtionEnv(data) {
  return action(SCENE_COLLECT_MNG, 'update', data)
}
